<div class="container-fluid">

    <div class="pageheader d-flex align-items-center justify-content-between mb-2">
        <h4 class="d-flex align-items-center mb-1">
               Users
         </h4>
    </div>

    <ul class="nav nav-underline nav-fill">
      <li class="nav-item" *ngIf="authService.canAdminInternalUsers()">
        <a class="nav-link"
          [class.active]="activeTab === 'internal'"
          (click)="activeTab = 'internal'">
          Internal
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link"
          [class.active]="activeTab === 'external'"
          (click)="activeTab = 'external'">
          External
        </a>
      </li>
    </ul>

    <div>
      <app-card>
      <app-internal-users-list *ngIf="activeTab === 'internal' && authService.canAdminInternalUsers()">
      </app-internal-users-list>
      <app-external-users-list *ngIf="activeTab === 'external'">
      </app-external-users-list>
    </app-card>
    </div>

</div>